import type { IComponentController, IFilterService, IScope } from "angular";

import type { IDaySchedule } from "App/Modules/Models";
import { DayType } from "App/Modules/Models";

export default class DaySchedulesComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$translate", "$filter"];

    public daySchedules: IDaySchedule[];

    public colorTheme: string;

    public staticDaySchedulesSource: any;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $filter: IFilterService,
    ) {}

    public getIsoWeekdayTranslation(weekdayNumber: number): string {
        if (weekdayNumber <= 7) {
            const weekdayTranslationFilter: (weekday: number) => string = this.$filter("irTranslateIsoWeekday");
            return weekdayTranslationFilter(weekdayNumber);
        }
        return this.$translate.instant(`Gui.Common.Weekdays.${DayType[weekdayNumber]}`);
    }
}
